<template>
    <div class="MMy">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
</template>

<script>
    export default {
        name: 'MMy',
        data() {
            return {}
        },
        methods: {},
        filters: {},
        watch: {},
        computed: {},
        components: {}
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .MMy {
    }
</style>